// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"d3f64dfb","532":"2016a180"}[chunkId] + ".chunk.css";
};